export { default } from './PatientImportantNotesIndicator';
